"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const AdminButton_1 = require("../AdminButton");
const styles_1 = require("./styles");
exports.HeaderInfo = (props) => {
    const [Height, setHeight] = react_1.useState("max");
    const [Style, setStyle] = react_1.useState({ "maxHeight": `1.25em` });
    function toggleHeaderInfo() {
        setHeight(Height === "min" ? "max" : "min");
        setStyle(Height === "max" ? { "minHeight": `1.25em` } : { "maxHeight": `1.25em` });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Info, { style: Style },
            react_1.default.createElement(styles_1.HeaderTitle, null, props.title),
            react_1.default.createElement(styles_1.HeaderUsername, null,
                props.username,
                react_1.default.createElement(AdminButton_1.AdminButton, { admin: props.admin }))),
        react_1.default.createElement(styles_1.MenuButton, { className: "btn btn-link", onClick: toggleHeaderInfo },
            react_1.default.createElement(fa_1.FaQuestionCircle, null))));
};
